import DynamicHero, { HeroTitle } from './DynamicHero';

export { HeroTitle };
export default DynamicHero;
